/* =========================================================
   HOME DECORE — Global JS
   Core utilities, scroll animation observer, header behavior,
   mobile nav, generic drawer/modal controller
   ========================================================= */

// ==========================================
// COMPLETE CONTENT PROTECTION CODE
// ==========================================

// 1. Disable text selection/highlighting via CSS injection
const style = document.createElement('style');
style.innerHTML = `
  * {
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
  }
  input, textarea {
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    user-select: text !important;
  }
`;
document.head.appendChild(style);

// 2. Disable right-click context menu
document.addEventListener('contextmenu', e => e.preventDefault());

// 3. Disable copy and cut actions
document.addEventListener('copy', e => e.preventDefault());
document.addEventListener('cut', e => e.preventDefault());

// 4. Disable drag and drop (protects images and text)
document.addEventListener('dragstart', e => e.preventDefault());

// 5. Disable common keyboard shortcuts (Ctrl/Cmd + C, U, I, S)
document.addEventListener('keydown', e => {
  const isModifier = e.ctrlKey || e.metaKey;
  if (isModifier && ['c', 'u', 'i', 's', 'p'].includes(e.key.toLowerCase())) {
    e.preventDefault();
  }
  // Disable F12 Developer Tools
  if (e.key === 'F12') {
    e.preventDefault();
  }
});


(function () {
  'use strict';

  window.HomeDecore = window.HomeDecore || {};

  /* ---------------- Money formatting (Shopify standard) ----------------
     Parses the shop's money_format string so currency symbol, decimals and
     separators always match the storefront. Never hardcodes a currency. */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format
      || (window.themeSettings && window.themeSettings.moneyFormat)
      || '{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = (thousands == null) ? ',' : thousands;
      decimal = (decimal == null) ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (Math.abs(number) / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? (decimal + parts[1]) : '';
      return whole + frac;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      default: value = withDelimiters(cents, 2);
    }
    var result = formatString.replace(placeholderRegex, value);
    return (cents < 0 ? '-' : '') + result;
  }
  window.HomeDecore.formatMoney = formatMoney;

  /* ---------------- Scroll reveal animations ---------------- */
  function initScrollAnimations() {
    var els = document.querySelectorAll('[data-animate]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-animate-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, parseInt(delay, 10));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------- Header scroll / hide-on-scroll ---------------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);

      if (header.dataset.autoHide === 'true') {
        if (y > lastY && y > 160) {
          header.classList.add('is-pinned-hidden');
        } else {
          header.classList.remove('is-pinned-hidden');
        }
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------------- Generic overlay panel controller ---------------- */
  // Handles [data-drawer], [data-modal] open/close with [data-open]/[data-close] triggers
  function initOverlayControllers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open]');
      if (opener) {
        var targetSel = opener.getAttribute('data-open');
        var target = document.querySelector(targetSel);
        if (target) {
          e.preventDefault();
          openOverlay(target);
        }
      }

      var closer = e.target.closest('[data-close]');
      if (closer) {
        var panel = closer.closest('.drawer, .modal, .mobile-nav, .filter-drawer, .search-drawer, .quick-view-modal');
        if (panel) {
          e.preventDefault();
          closeOverlay(panel);
        }
      }

      // Click on overlay background closes
      if (e.target.classList.contains('drawer__overlay') ||
          e.target.classList.contains('modal__overlay') ||
          e.target.classList.contains('mobile-nav__overlay') ||
          e.target.classList.contains('filter-drawer__overlay') ||
          e.target.classList.contains('search-drawer__overlay') ||
          e.target.classList.contains('quick-view-modal__overlay')) {
        closeOverlay(e.target.parentElement);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var openPanel = document.querySelector('.is-open');
        if (openPanel) closeOverlay(openPanel);
      }
    });
  }

  function syncHamburger(open) {
    var btn = document.querySelector('.hamburger');
    if (!btn) return;
    btn.classList.toggle('is-active', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openOverlay(el) {
    closeAllOverlays();
    el.classList.add('is-open');
    document.documentElement.classList.add('no-scroll');
    if (el.hasAttribute('data-mobile-nav') || el.classList.contains('mobile-nav')) {
      syncHamburger(true);
    }
    var focusable = el.querySelector('input, button, [tabindex]');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 350);
    el.dispatchEvent(new CustomEvent('overlay:open'));
  }

  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    if (el.hasAttribute('data-mobile-nav') || el.classList.contains('mobile-nav')) {
      syncHamburger(false);
    }
    if (!document.querySelector('.is-open')) {
      document.documentElement.classList.remove('no-scroll');
    }
    el.dispatchEvent(new CustomEvent('overlay:close'));
  }

  function closeAllOverlays() {
    document.querySelectorAll('.is-open').forEach(function (el) {
      if (el.hasAttribute('data-mobile-nav') || el.classList.contains('mobile-nav')) {
        syncHamburger(false);
      }
      el.classList.remove('is-open');
    });
  }

  window.HomeDecore.openOverlay = openOverlay;
  window.HomeDecore.closeOverlay = closeOverlay;
  window.HomeDecore.closeAllOverlays = closeAllOverlays;

  /* ---------------- Mobile nav submenu accordions ---------------- */
  function initMobileNavAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.mobile-nav__link[data-submenu-toggle]');
      if (!trigger) return;
      e.preventDefault();
      var item = trigger.closest('.mobile-nav__item');
      item.classList.toggle('is-open');
    });
  }

  /* ---------------- Accordion (product page tabs, FAQ) ---------------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.accordion__trigger');
      if (!trigger) return;
      var accordion = trigger.closest('.accordion');
      var panel = accordion.querySelector('.accordion__panel');
      var isOpen = accordion.classList.contains('is-open');
      var group = accordion.closest('.accordion-group');
      var exclusive = group && group.dataset.exclusive === 'true';

      if (exclusive) {
        group.querySelectorAll('.accordion.is-open').forEach(function (other) {
          if (other !== accordion) {
            other.classList.remove('is-open');
            other.querySelector('.accordion__panel').style.maxHeight = null;
          }
        });
      }

      if (isOpen) {
        accordion.classList.remove('is-open');
        panel.style.maxHeight = null;
      } else {
        accordion.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }

  /* ---------------- Quantity steppers ---------------- */
  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-stepper__plus, .qty-stepper__minus');
      if (!btn) return;
      var stepper = btn.closest('.qty-stepper');
      var input = stepper.querySelector('input');
      var min = parseInt(input.min, 10);
      if (!min || min < 1) min = 1;
      var maxAttr = parseInt(input.max, 10);
      var max = (input.max && !isNaN(maxAttr) && maxAttr >= min) ? maxAttr : Infinity;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < min) val = min;

      if (btn.classList.contains('qty-stepper__plus')) {
        val = Math.min(max, val + 1);
      } else {
        val = Math.max(min, val - 1);
      }
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------- Newsletter form (theme-agnostic UX feedback) ---------------- */
  function initNewsletterForms() {
    // The Shopify {%- form -%} tag renders as a <form> element that wraps .newsletter-form div.
    // We listen on the <form> element (parent of .newsletter-form), not the div itself.
    document.querySelectorAll('.newsletter-form').forEach(function (newsletterDiv) {
      var form = newsletterDiv.closest('form');
      if (!form) return;
      form.addEventListener('submit', function () {
        var section = form.closest('.newsletter-section');
        var success = section && section.querySelector('.newsletter-section__success');
        if (success) {
          setTimeout(function () { success.classList.add('is-active'); }, 50);
        }
      });
    });
  }

  /* ---------------- Global Quick-Add (product card hover ATC button) ----------------
     collection.js only runs on collection pages (early return guard).
     This handler covers ALL pages: homepage, search, featured-collection sections, etc. */
  function initGlobalQuickAdd() {
    document.addEventListener('click', function (e) {
      var quickAddBtn = e.target.closest('[data-quick-add-btn]');
      if (!quickAddBtn) return;

      // Prevent double-fire if collection.js also matched (on collection pages collection.js handles it)
      if (quickAddBtn._quickAddPending) return;

      var variantId = quickAddBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      // aria-disabled = out of stock, do nothing
      if (quickAddBtn.getAttribute('aria-disabled') === 'true') return;

      // CartAPI may not be ready yet on very first paint — guard it
      if (!window.HomeDecore || !window.HomeDecore.CartAPI) return;

      quickAddBtn._quickAddPending = true;
      var originalText = quickAddBtn.innerHTML;
      quickAddBtn.setAttribute('aria-disabled', 'true');
      quickAddBtn.innerHTML = 'Adding…';

      window.HomeDecore.CartAPI.add([{ id: variantId, quantity: 1 }])
        .then(function () {
          if (window.HomeDecore.refreshCart) return window.HomeDecore.refreshCart();
        })
        .then(function () {
          var drawer = document.querySelector('[data-cart-drawer]');
          if (drawer && window.HomeDecore.openOverlay) window.HomeDecore.openOverlay(drawer);
          quickAddBtn.innerHTML = '&#10003; Added';
          setTimeout(function () {
            quickAddBtn.innerHTML = originalText;
          }, 1800);
        })
        .catch(function (err) {
          var msg = (err && err.description) || 'Could not add to cart.';
          alert(msg);
          quickAddBtn.innerHTML = originalText;
        })
        .finally(function () {
          quickAddBtn.removeAttribute('aria-disabled');
          quickAddBtn._quickAddPending = false;
        });
    });
  }

  /* ---------------- Init ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initScrollAnimations();
    initHeaderScroll();
    initOverlayControllers();
    initMobileNavAccordions();
    initAccordions();
    initQuantitySteppers();
    initNewsletterForms();
    initGlobalQuickAdd();
  });
})();
